import React from 'react';
import {Box, Text, Card, Flex} from '@radix-ui/themes';
import { CheckCircledIcon, ExclamationTriangleIcon, InfoCircledIcon, CrossCircledIcon } from '@radix-ui/react-icons';

const MessageBox = ({ type, title, message, options }) => {

  const colorMap = {
    success: 'green',
    info: 'blue',
    warning: 'yellow',
    error: 'red',
  };

  const iconMap = {
    success: <CheckCircledIcon />,
    info: <InfoCircledIcon />,
    warning: <ExclamationTriangleIcon />,
    error: <CrossCircledIcon />,
  };

  const Icon = iconMap[type] || null; // Default to no icon if type is unknown

  return (
    <Card p="4" mb="4">
        
        <Flex direction="row" justify="start" gap="2" align="center">
            {Icon && Icon}
            {title && <Text size="2" weight="bold" color={colorMap[type] || 'gray'}>{title}</Text>}
        </Flex>
        <Text size="1" as="p" mt="4">{message}</Text>
        {options?.extraText && (
            <Text size="1" as="p" mt="4">{options.extraText}</Text>
        )}
    </Card>
  );
};

export default MessageBox;
